module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBracelets@2x.3513744.jpg";